// extracted by mini-css-extract-plugin
module.exports = {"codebar":"CodeBar_codebar__1kQA6","tab":"CodeBar_tab__c1fTZ","item":"CodeBar_item__35U4C","activeTab":"CodeBar_activeTab__1EPRu","editor":"CodeBar_editor__3_NI7"};